import moment from 'moment';

/**
 * 集中管理されたブランディングまたはビジネスロジック定数
 * Centralized business logic constants
 */
export const BUSINESS_DATA = {
  /**
   * ログインページに表示する画像
   * Image to show on login page
   */
  LOGIN_IMAGE: require('@/assets/images/letsSYSTEM.png'),

  /**
   * ドキュメントアイコンとサイドバーについて、同じ名前の画像に置き換えてください。
   * for document icon and sidebar ,replace with image with same name
   *
   * @/assets/images/favicon.png
   */

  /**
   * サイドバーのタイトルおよびドキュメントのタイトルとして使用
   * Use as siderbar title and document title
   */
  APP_TITLE: import.meta.env.VITE_APP_TITLE,

  /**
   *
   * 使用済み: 生徒カルテ (WAMの当科目の宿題で１日に使える平均時間)
   */
  APP_SHORT_TITLE: 'LetsSYSTEM',

  /**
   * Footer text
   */
  APP_FOOTER: `© ${moment().year()} WiZLiNK Inc.`,

  APP_PRIMARY_COLOR: '#FF8F00',
  APP_ON_PRIMARY_COLOR: '#FFF',
  APP_SECONDARY_COLOR: '#FFF3E0',

  APP_DEFAULT_LANGUAGE: 'ja',
  // APP_DEFAULT_LANGUAGE: 'zhHant',

  M20901:{
    /**
     * Must match with backend
     */
    // ISSUE_HIGH: security issue, should not put default password in the frontend code
    DEFAULT_PW: 'hwam5'
  }
}

export default BUSINESS_DATA
